import React from 'react';

const Review = ({review}) => {
    const {name,email,message,address,reviewTitle,image} = review
    return (
        <div className='grid gap-5 gird-cols-1 md:grid-cols-2 lg:grid-cols-4 border m-4 rounded items-center text-center content-center'>
           <div>
           <img className='w-30 h-30 rounded p-2' src={image} alt="" />
           </div>
           <p>Email: {email}</p>
           <p>Message: {message}</p>
           <p className='text-2xl'> Name: {name}</p>
        </div>
    );
};

export default Review;